export default function(){
    (function($) {
        var headerHeight = 0;
        var homePage = false;

        $(window).on('load', function(){
            if ($('body').hasClass('home')){
                homePage = true;
            } else {
                $('.navigation__menu').slideDown(100);
            }
        });


        function navigationToggle(){
            var windowWidth = $(window).width();
            var scrolledOverHeader = false;
            headerHeight = $('.header').outerHeight() - 100;
            var menuOpened = false;
            if (!homePage){
                menuOpened = true;
            }
            if (windowWidth > 991){
                $(window).scroll(function () {
                    // if (!homePage){
                        if ($(window).scrollTop() > headerHeight) {
                            if (!scrolledOverHeader && !menuOpened) {
                                menuOpened = true;
                                $('.navigation').addClass('navigation_opened ');
                                $('.navigation__menu').slideDown(130);
                                $(".navigation__hamburger-icon").addClass("navigation__hamburger-icon--opened");
                            }
                            scrolledOverHeader = true;
                            $('.navigation').addClass(' navigation_scrolled');
                        } else {
                            if (homePage) {
                                $('.navigation').removeClass('navigation_scrolled');
                                scrolledOverHeader = false;
                            }
                        }
                    // }
                })
                $('.navigation__header').on('click', function (e) {
                    // e.preventDefault();
                    if (!menuOpened){
                        $(this).next('.navigation__menu').slideDown(130);
                    } else {
                        $(this).next('.navigation__menu').slideUp(130);
                    }
                    menuOpened = !menuOpened;
                })
            } else {
                $(window).scroll(function () {
                    if ($(window).scrollTop() > headerHeight) {
                        $('.navigation').addClass(' navigation_scrolled');
                    } else {
                            $('.navigation').removeClass('navigation_scrolled');
                    }
                })
                $('.navigation__items a').on('click', function (){
                    $('html').removeClass("hidden-mb");
                    $('.navigation__menu').removeClass("navigation__menu-open");
                    $('.navigation').removeClass('navigation_opened');
                    $(".navigation__hamburger-icon").removeClass("navigation__hamburger-icon--opened");
                });
            }
            $('.navigation__header').on('click', function () {
                $(this).next('.navigation__menu').toggleClass("navigation__menu-open");
                $('html').toggleClass("hidden-mb");
                $('.navigation').toggleClass('navigation_opened');
                $(".navigation__hamburger-icon").toggleClass("navigation__hamburger-icon--opened");
                // menuOpened = !menuOpened;
            })
        }

        $(window).on('load resize', function(){
            navigationToggle();
        });

        var $resizedToDesktop = 'desktop';
        $(window).on('resize', function(){
            var windowWidth = $(window).width();
            if (windowWidth > 991){
                if ($resizedToDesktop === 'mobile') {
                    $('.navigation__menu').removeClass("navigation__menu-open");
                    $('html').removeClass("hidden-mb");
                    $('.navigation').removeClass('navigation_opened');
                    $(".navigation__hamburger-icon").removeClass("navigation__hamburger-icon--opened");
                    $resizedToDesktop = 'desktop';
                }
            } else {
                if ($resizedToDesktop === 'desktop'){
                    $('.navigation__menu').hide().removeClass("navigation__menu-open");
                    $('html').removeClass("hidden-mb");
                    $('.navigation').removeClass('navigation_opened');
                    $(".navigation__hamburger-icon").removeClass("navigation__hamburger-icon--opened");
                    $resizedToDesktop = 'mobile';
                }
            }
        });

        $(window).on('load', function(){
            headerHeight = $('.header').outerHeight() - 100;
            if ($(window).scrollTop() > headerHeight || !homePage) {
                $('.navigation').addClass(' navigation_scrolled');
            }
            if (!homePage){
                // menuOpened = !menuOpened;
                $(".navigation__hamburger-icon").toggleClass("navigation__hamburger-icon--opened");
            }
        });








// change color of menu when scrolled to anchor
        $(document).ready(function(){
            $('.anchor').each(function () {
                $(this).parent().addClass('anchor-parent');
            });
            $(window).scroll(function() {
                var windowTop = Math.max($('body').scrollTop(), $('html').scrollTop());
                var id = "";
                $('.anchor').each(function () {
                    if ($(this).attr("id").length > 0) {
                        if (windowTop > ($(this).position().top - 200)) {
                            id = $(this).attr("id");
                        }
                    }
                });
                $('.navigation__items_anchors a').each(function () {
                    if ($(this).attr("href").length > 0) {
                        var url = $(this).attr("href");
                        var hash = url.indexOf("#");
                        var urlId = hash != -1 ? url.substring(hash+1) : "";
                        if (urlId == id) {
                            $(this).addClass("navigation__items_highlight");

                        } else {
                            $(this).removeClass("navigation__items_highlight");
                        }
                    }
                });
            }).scroll();




        });


        //copy anchor link to clipboard on click
        $('.anchor').click(function () {
            $(this).addClass("animate").delay(100).queue(function(next) {
                $(this).removeClass("animate");
                next();
            });
            let str = window.location.href.split("#")[0] + '#' + $(this).attr('id');
            const el = document.createElement('textarea');
            el.value = str;
            el.setAttribute('readonly', '');
            el.style.position = 'absolute';
            el.style.left = '-9999px';
            document.body.appendChild(el);
            el.select();
            document.execCommand('copy');
            document.body.removeChild(el);
        })





        $(".nav__content").on("transitionend", function () {
            if(!menuOpened){
                $(".nav__container").removeClass("nav--black-bg");
            }
        })

        $(".nav__content").on("transitionend", function () {
            if(!menuOpened){
                $(".nav__container").removeClass("nav--black-bg");
            }
        })

        $(".nav__link").on("click", function () {
            if($(".navigation").hasClass("opened")){
                $(".navigation").removeClass("opened");
            }
        })

        $(".menu-item-has-children").on("click", function () {
            $(".menu-item-has-children > .sub-menu").toggleClass("sub-menu--opened");
            $(this).toggleClass("menu-item--opened");
        })

        const nav = $(".nav__mobile-header");
        $(window).scroll( function () {
            if(window.pageYOffset > 0){
                nav.addClass("nav__mobile-header--background")
            } else {
                nav.removeClass("nav__mobile-header--background")
            }
        })

        $(window).scroll(function(e) {
            e.preventDefault();
            if ($(window).scrollTop() > 100 || $(window).scrollTop() > 100 && $('body').hasClass('sidebar-cart-opened')) {
                $('.navigation').addClass("scrolled");
            } else {
                $('.navigation').removeClass("scrolled");
            }
        });

        // Script
        let lastScroll = 0;
        $(window).on('scroll',function() {
            var scroll = $(window).scrollTop();
            if(lastScroll - scroll > 0) {
                $(".navigation").addClass("scrollUp");
            } else {
                $(".navigation").removeClass("scrollUp");
            }
            lastScroll = scroll;
        });







        // Sidebar cart


        var fromTop;
        function sidebar_cart_open(){
            // Fix content
            fromTop = $(window).scrollTop();
            $(".body-content").css({
                position: "fixed",
                top: -fromTop,
                width: "100%"
            });
            if($('body').hasClass('sidebar-cart-opened')){
                sidebar_cart_close();
            }
            if (fromTop > 100) {
                $(".navigation").addClass("scrolled");
            }
            // Add body class
            $('body').addClass('sidebar-cart-opened');

        }

        function sidebar_cart_close(){
            $('body').removeClass('sidebar-cart-opened');

            $(".body-content").removeAttr("style");
            $(window).scrollTop(fromTop);
            $(".navigation.scrolled.scrollUp").css ({
                top: "0",
            });
            if ($(window).scrollTop() > 100 ) {
                $('.navigation').addClass("scrolled");
            }
        }


        function sidebar_cart_init(){

            $('.body-content, .sidebar-cart__close').click(function(e){
                if($('body').hasClass('sidebar-cart-opened')){
                    sidebar_cart_close();
                }
            });


        }


        $('body').on('click','.header__icon_cart, .open-cart', function(e){
            e.preventDefault();

            setTimeout( sidebar_cart_open , 1 );

        });

        $(function() {
            sidebar_cart_init();
        });

        $( document.body ).on( 'wc_fragments_refreshed', () => {
            sidebar_cart_init();
        } );


        $( document ).on( "creepy-add-to-cart-success", function() {
            sidebar_cart_init();
            sidebar_cart_open();
        });

        $( document ).on( "creepy-add-to-cart-error", function() {
            document.body.scrollTop = 0; // For Safari
            document.documentElement.scrollTop = 0; // For Chrome, Firefox, IE and Opera

            $("button.single_add_to_cart_button").attr("disabled", true)

            setTimeout(() => {
                $("button.single_add_to_cart_button").attr("disabled", false)
            }, 5000)

        });







    })(jQuery);
}